export default __webpack_public_path__ + "static/media/nodata.7e0f2d64.svg";